export const noteCss = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900');
  .print {
    color: #000;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    padding: 20mm 2mm;
    margin: 0;
    width: 210mm;
  }
  h1 { font-size: 24px; }
  h2 { font-size: 18px; }
  h3 { font-size: 16px; }
  h1, h2, h3 { margin-top: 12px; margin-bottom: 8px; }
  ul, ol { font-size: 12px; line-height: 1.4; padding-left: 12px; }
  p { padding: 0.25em; margin-top: 0.5em; }
  img { margin: 10px 5px; }
  .no-print { display: none; }
`;

export const noteA4Css = `
  .site-note-pdf__content {
    color: #0f172a;
    font-size: 12px;
    line-height: 1.7;
    overflow-wrap: anywhere;
  }

  .site-note-pdf__content > :first-child {
    margin-top: 0;
  }

  .site-note-pdf__content > :last-child {
    margin-bottom: 0;
  }

  .site-note-pdf__content h1,
  .site-note-pdf__content h2,
  .site-note-pdf__content h3,
  .site-note-pdf__content h4,
  .site-note-pdf__content h5,
  .site-note-pdf__content h6 {
    margin: 0 0 3mm;
    font-weight: 700;
    line-height: 1.2;
  }

  .site-note-pdf__content h1 { font-size: 22px; }
  .site-note-pdf__content h2 { font-size: 18px; }
  .site-note-pdf__content h3 { font-size: 15px; }
  .site-note-pdf__content h4 { font-size: 13px; }

  .site-note-pdf__content p,
  .site-note-pdf__content ul,
  .site-note-pdf__content ol,
  .site-note-pdf__content blockquote {
    margin: 0 0 3mm;
  }

  .site-note-pdf__content ul,
  .site-note-pdf__content ol {
    padding-left: 5mm;
  }

  .site-note-pdf__content li + li {
    margin-top: 1mm;
  }

  .site-note-pdf__content blockquote {
    margin-left: 0;
    padding-left: 4mm;
    border-left: 1px solid #cbd5e1;
    color: #475569;
  }

  .site-note-pdf__content img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 4mm 0;
    border-radius: 3mm;
  }

  .site-note-pdf__content .ql-align-center { text-align: center; }
  .site-note-pdf__content .ql-align-right { text-align: right; }
  .site-note-pdf__content .ql-align-justify { text-align: justify; }
`;
